import { useContext } from 'react';
import { Icon, ModalContainer, ModalContent, Overlay, Title } from 'ui/styled';
import {
  CloseContainer,
  ColumnContent,
  CompanyDataContainer,
  ContainerColumn,
  HeaderExtra,
  TituloArea,
} from './styled';

import { CoreContext } from 'context/CoreContext';

export default function WrapperTwoCol({
  children,
  children2,
  banner,
  footer,
  onClose,
  title = null,
  headerContent = null,
  titleColumn1 = null,
  titleColumn2 = null,
  width,
  height,
}) {
  const { setModal } = useContext(CoreContext);
  //adiciona funcionalidade de fechar ao clicar fora do modal via prop ou contexto
  const close = () => {
    //agora permti passar via func de fechamento externa
    if (typeof onClose === 'function') {
      onClose();
    } else {
      setTimeout(async () => {
        setModal(null);
      }, 500);
    }
  };

  const handleClose = (e) => {
    const mc = document.getElementById('modal-content');
    if (!mc?.contains(e?.target) && !(e?.target.tagName === 'LI')) {
      //Desabilidado funcionalidade de fechar o modal ao clicar fora
      //close();
    }
  };

  // Com height o modal deixa de acompanhar o conteudo: as colunas rolam por
  // dentro e o rodape fica sempre visivel.
  const fixo = !!height;

  // Sem titulo a coluna nao ganha cabecalho — util quando quem rotula o
  // conteudo e outra coisa, como uma barra de abas.
  const coluna = (titulo, conteudo) => (
    <ContainerColumn $fill={fixo}>
      {titulo ? (
        <Title nomargin small>
          {titulo}
        </Title>
      ) : null}
      {fixo ? <ColumnContent>{conteudo}</ColumnContent> : conteudo}
    </ContainerColumn>
  );

  return (
    <Overlay onClick={handleClose}>
      <ModalContainer>
        <ModalContent
          id="modal-content"
          width={width || '60vw'}
          $height={height}
        >
          <CompanyDataContainer>
            <CloseContainer>
              <TituloArea>
                <Title nomargin>{title ? title : 'Oferta'}</Title>
                {headerContent ? (
                  <HeaderExtra>{headerContent}</HeaderExtra>
                ) : null}
              </TituloArea>
              <Icon icon={'close-big'} pointer={true} onClick={close} />
            </CloseContainer>
          </CompanyDataContainer>
          {banner && (
            <CompanyDataContainer $auto={fixo}>{banner}</CompanyDataContainer>
          )}
          <CompanyDataContainer $body={fixo}>
            {coluna(titleColumn1, children)}
            {children2 && coluna(titleColumn2, children2)}
          </CompanyDataContainer>
          {footer && (
            <CompanyDataContainer $auto={fixo}>{footer}</CompanyDataContainer>
          )}
        </ModalContent>
      </ModalContainer>
    </Overlay>
  );
}
